<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
  import pageTemplate from "@/components/template/pageTemplate";
  import formDialog from "@/components/template/formDialog";
  import api from "@/config/api";

  export default {
    components: {
      formDialog,
      pageTemplate,
    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: "单号", prop: "name", type: "input", ifFuzzy: true, placeholder: "请输入单号"},
            {label: "交易类型", prop: "name", type: "input", ifFuzzy: true, placeholder: "请输入交易类型"},
          ],
          complex: [
            {label: "日期", prop: "startTime", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: "设置",
            code: 'set',
          },
          {
            label: "打印",
            code: 'print',
          },
          {
            label: "导出",
            code: 'export',
          },
          {
            label: "编辑",
            code: 'update',
            type: this.$utils.buttonType.tableOperate
          },
        ],
        // 表格信息配置
        tableOptions: {
          columns: [
            {label: "ID", prop: "id", width: "50", align: "center"},
            {
              label: "单号",
              prop: "loginName",
              width: "120",
              align: "center"
            },
            {label: "时间", prop: "name", width: "120", align: "center"},
            {
              label: "国税",
              prop: "descr",
              width: "120",
              align: "center",
            },
            {
              label: "地税",
              prop: "descr",
              width: "120",
              align: "center",
            },
            {
              label: "金额",
              prop: "descr",
              width: "120",
              align: "center",
            }
          ],
          url: api.system.account
        },
      };
    },
    methods: {}
  };
</script>




// WEBPACK FOOTER //
// src/page/system/maintain/rap/Summary.vue